import { Shimmer } from "../styles"

export const PageLoaderShow = () => {
    return (
        <div style={{paddingInline: '30px'}}>
            <Shimmer style={{marginTop: '32px', height: '103px'}}></Shimmer>
            <Shimmer style={{marginTop: '32px', height: '276px'}}></Shimmer>
        </div>
    )
}